module.exports = __webpack_public_path__ + "img/tree-2.338c9ed1.png";